import styled from 'styled-components';

import { convertPxToRem } from '@proprioo/salatim';

export const SkeletonWrapper = styled.div`
  margin-top: ${convertPxToRem(24)};
`;
